// Dependencies
import React from 'react';
import Routes from './Routes';

// App component
function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
